import React, { Component } from "react";

import styled from "styled-components";

class AlertBox extends Component {
    state = {
        hide: false
    }

  render() {
    const { className } = this.props;
    return (
      <div className={className}>
        <div className="banner-wrap">{this.props.alertTxt}</div>
      </div>
    );
  }
}

export default styled(AlertBox)`
  position: sticky;
  top: 0;
  z-index: 11;

  .banner-wrap {
    text-align: center;
    color: #fff;
    background-color: #9c0000;
    padding: 20px;
    position: sticky;
    top: 0;
    z-index: 9;
  }
`;



// WEBPACK FOOTER //
// ./src/components/AlertBox.js